import {
	INotificationDataEvent,
	notificationContext,
} from '../contexts/notification.context';
import { useContext, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { getUnreadMessagesCount } from '../reduxStore';
import { newMessagesNotificationMessages } from './newMessagesNotification.i18n';

export const useNewMessagesNotification = () => {
	const newMessagesCount = useSelector(getUnreadMessagesCount);
	const { sendNotification } = useContext(notificationContext);
	const intl = useIntl();

	const newMessagesText = intl.formatMessage(
		newMessagesNotificationMessages.new_messages_notification_body,
		{ count: newMessagesCount }
	);
	const newMessagesTitle = intl.formatMessage(
		newMessagesNotificationMessages.new_messages_notification_title
	);
	const prevCount = useRef<number>(undefined);

	useEffect(() => {
		if (newMessagesCount && prevCount.current !== newMessagesCount) {
			const event: INotificationDataEvent = {
				type: 'new_messages',
				payload: {
					title: newMessagesTitle,
					options: {
						body: newMessagesText,
						tag: 'New messages',
					},
				},
			};
			sendNotification(event);
		}
		prevCount.current = newMessagesCount;
	}, [newMessagesCount, sendNotification, newMessagesText, newMessagesTitle]);
};
